import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";
import { BrandMark } from "../components/BrandMark";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [passcode, setPasscode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { passcode });
      setToken(data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch {
      toast.error("Incorrect passcode.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col" data-testid="admin-login-page">
      <header className="max-w-6xl w-full mx-auto px-6 lg:px-10 pt-8">
        <BrandMark />
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <div className="bg-white border border-[#E5E5E0] rounded-2xl p-10 shadow-sm">
            <div className="w-12 h-12 rounded-full bg-[#010082]/10 flex items-center justify-center">
              <Lock className="w-5 h-5 text-[#010082]" strokeWidth={1.5} />
            </div>
            <h1 className="font-serif-display text-3xl text-[#1A1A1A] mt-6 tracking-tight">
              Admin access
            </h1>
            <p className="text-[13px] text-[#737373] mt-2">
              Enter the office passcode to review submissions.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <Input
                type="password"
                placeholder="Passcode"
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
                className="h-12 bg-white border border-[#E5E5E0] rounded-lg focus-visible:ring-2 focus-visible:ring-[#010082] focus-visible:border-[#010082]"
                data-testid="admin-passcode-input"
              />
              <Button
                type="submit"
                disabled={loading || !passcode}
                className="w-full h-12 bg-[#010082] hover:bg-[#010082]/90 text-white rounded-lg"
                data-testid="admin-login-button"
              >
                {loading ? "Signing in…" : "Sign in"}
              </Button>
            </form>
          </div>
          <div className="text-center mt-6">
            <a
              href="/"
              className="text-[12px] uppercase tracking-[0.2em] text-[#737373] hover:text-[#010082] transition-colors"
              data-testid="back-to-site-link"
            >
              ← Back to site
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
